import { render, staticRenderFns } from "./CatRates.vue?vue&type=template&id=5adc8b82&scoped=true&"
import script from "./CatRates.vue?vue&type=script&lang=js&"
export * from "./CatRates.vue?vue&type=script&lang=js&"
import style0 from "./CatRates.vue?vue&type=style&index=0&id=5adc8b82&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adc8b82",
  null
  
)

export default component.exports